import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AiFillCaretLeft, AiFillCaretRight } from "react-icons/ai";
import "../../Styles/HomeMap.css";
import Legend from "./Legend";
import Sidebar from "../Sidebar";
import Chart from "./Chart";
import ReligionPageSide from "../ReligionPageSide";
import mapboxgl from 'mapbox-gl';
import { world_religion } from "./WorldReligion";
import Scale1 from '../../Assets/stripe1.jpg';
import Scale2 from '../../Assets/stripe2.jpg';
import Scale3 from '../../Assets/stripe2.jpg';

mapboxgl.accessToken = 'pk.eyJ1IjoiZWRtYW4iLCJhIjoiY2syNWs1ajk3MGM2NjNua3gxYTNhdWpkOSJ9.ngu-SlVjhLdLBPyDFFsIBw';

const HinduismPage = () => {
    const mapContainer = useRef(null);
    const map = useRef(null);
    const [lng, setLng] = useState(-70.9);
    const [lat, setLat] = useState(42.35);
    const [zoom, setZoom] = useState(1);
    const [buddhism_hover, setBuddhism_hover] = useState(false);
    const [east_hover, setEast_hover] = useState(false);
    const [hinduism_hover, setHinduism_hover] = useState(false);
    const [islam_hover, setIslam_hover] = useState(false);
    const [christianity_hover, setChristianity_hover] = useState(false);
    const [other_hover, setOther_hover] = useState(false);
    const [firstReligion, setFirstReligion] = useState("...");
    const [secondReligion, setSecondReligion] = useState("...");
    const [province, setProvince] = useState("...");
    const [country, setCountry] = useState("...");
    const [numerical, setNumerical] = useState(null);
    const [numeric_1, setNumeric_1] = useState(null);
    const [year, setYear] = useState("...");
    const [dataSource, setDataSource] = useState("...");
    const [display, setDisplay] = useState("map");
    const buddhismSubs= ["Tibetan","Theravada","Mahayana"];
    let hoveredStateId = null;

    useEffect(() => {
        if (map.current) return; // initialize map only once
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/light-v10',
            center: [lng, lat],
            zoom: zoom,
            maxZoom: 5,
            renderWorldCopies: false,
        });
        map.current.addControl(new mapboxgl.NavigationControl());
    }, []);

    useEffect(() => {
        map.current.on('load', () => {
            map.current.addSource('world_religion', {
                'type': 'vector',
                'url': 'mapbox://edman.BRI_Religion_JSON2'
            });
            map.current.addLayer(world_religion, 'state-label');
            map.current.addLayer({
                'id': 'state-fills',
                'type': 'fill',
                'source': 'world_religion',
                'source-layer': 'BRI_Religion_JSON2',
                'layout': {},
                'paint': {'fill-color': 'transparent','fill-outline-color':'black','fill-opacity': ['case',['boolean', ['feature-state', 'click'], false],1,0]}
                }
            );
            map.current.addLayer({
                'id': 'hover-fills',
                'type': 'line',
                'source': 'world_religion',
                'source-layer': 'BRI_Religion_JSON2',
                'layout': {},
                'paint': {'line-width': 1}
                },'state-label'
            );

        });

        map.current.on('mousemove', 'state-fills', (e) => {
            map.current.setFilter("hover-fills", [
                "any",
                ["==", "ProvName", e.features[0].properties.ProvName],
              ]);
            setFirstReligion(e.features[0].properties.HighRelig);
            setSecondReligion(e.features[0].properties.SecRelig);
            setProvince(e.features[0].properties.ProvName);
            setCountry(e.features[0].properties.Country);
            setNumerical(e.features[0].properties.Numerical);
            setNumeric_1(e.features[0].properties.Nummeric_1);
            setYear(e.features[0].properties.Year);
            setDataSource(e.features[0].properties.DataSource);
            
        });
        map.current.on('click', 'hover-fills', (e) => {
            map.current.setFilter("hover-fills", [
                "any",
                ["==", "ProvName", e.features[0].properties.ProvName],
              ]);
            setFirstReligion(e.features[0].properties.HighRelig);
            setSecondReligion(e.features[0].properties.SecRelig);
            setProvince(e.features[0].properties.ProvName);
            setCountry(e.features[0].properties.Country);
            setNumerical(e.features[0].properties.Numerical);
            setNumeric_1(e.features[0].properties.Nummeric_1);
            setYear(e.features[0].properties.Year);
            setDataSource(e.features[0].properties.DataSource);
            
        });
        map.current.on('mouseleave', 'state-fills', () => {
            map.current.setFilter("hover-fills", false);}
        );

        map.current.on('load', () => {
          map.current.setFilter("world_religion", [
            "any",
            ["==", "HighRelig", "Hindus"],
          ]);
          map.current.setFilter("state-fills", [
            "any",
            ["==", "HighRelig", "Hindus"],
          ]);
          map.current.setFilter("hover-fills", false);
          map.current.flyTo({
            center: [80, 20],
            zoom: 2.5,
          });
              })

        
    }, []);
    

    return (
        <div className="homeMap">
            <Link to="/" style={{fontSize:"3vh",lineHeight:"5vh",textDecoration:"none", position:"absolute", top:"2vh",left:"10px", color:"#DDDDDD"}}>
                <div className="backButton"> <AiFillCaretLeft size={28} style={{verticalAlign:"bottom"}}/>Full Map Mode</div>
            </Link>
            <div className="religionPageList">
                <div onMouseOver={()=>setBuddhism_hover(true)} onMouseLeave={()=>setBuddhism_hover(false)}>
                  <div className="religionPageMain" style={{backgroundColor:"#AC7339"}}>The Hindu World</div>
                </div>
                <div onMouseOver={()=>setEast_hover(true)} onMouseLeave={()=>setEast_hover(false)}>
                  <Link to="/Buddhism" style={{textDecoration:"none"}}>
                    <div className="religionPageOther r navB"><div className='sideIcon buddhism'></div></div>
                  </Link>
                </div>
                <div onMouseOver={()=>setChristianity_hover(true)} onMouseLeave={()=>setChristianity_hover(false)}>
                  <Link to="/East" style={{textDecoration:"none"}}>
                    <div className="religionPageOther r navE"><div className='sideIcon eastasian'></div></div>
                  </Link>
                </div>
                <div onMouseOver={()=>setIslam_hover(true)} onMouseLeave={()=>setIslam_hover(false)}>
                  <Link to="/Islam" style={{textDecoration:"none"}}>
                    <div className="religionPageOther r navI"><div className='sideIcon islam'></div></div>
                  </Link>
                </div>
                <div onMouseOver={()=>setHinduism_hover(true)} onMouseLeave={()=>setHinduism_hover(false)}>
                  <Link to="/Christianity" style={{textDecoration:"none"}}>
                    <div className="religionPageOther r navC"><div className='sideIcon christianity'></div></div>
                  </Link>
                </div>
                <div onMouseOver={()=>setOther_hover(true)} onMouseLeave={()=>setOther_hover(false)}>
                  <Link to="/Other" style={{textDecoration:"none"}}>
                    <div className="religionPageOther r navO"><div className='sideIcon other'></div></div>
                  </Link>
                </div>
            </div>
            <div className="homeMapMain">
                <ReligionPageSide religion="Hinduism" country={country} province={province} firstReligion={firstReligion} numerical={numerical} secondReligion={secondReligion}
                numeric_1={numeric_1} year={year} dataSource={dataSource}/>
                <div ref={mapContainer} className="religion-map-container" />
                
            </div>
            
            <div className="bottomBar"><AiFillCaretRight style={{verticalAlign:"bottom"}}/>Customization of the map view</div>
            <div className='chart'>
                <div style={{width:"33.33%"}}>
                    <div style={{color:"black",background:"transparent linear-gradient(270deg, #FFFFDB 0%, #FDFD9E 40%, #FCFD4A 60%, #CACA2A 99%, #CACA2A 100%) 0% 0%"}}>Buddhism[Tibetan]</div>
                </div>
                <div style={{width:"33.33%"}}>
                    <div style={{color:"black",background:"transparent linear-gradient(270deg, #FFF4DC 0%, #FCD77E 40%, #FDB434 60%, #E49A25 100%) 0% 0%"}}>Buddhism[Theravada]</div>
                </div>
                <div style={{width:"33.33%"}}>
                    <div style={{color:"black",background:"transparent linear-gradient(270deg, #FDC2B4 0%, #FD7454 40%, #FD3D20 60%, #CA3017 100%) 0% 0%"}}>Buddhism[Mahayana]</div>
                </div>
            </div>
        </div>
    );
};

export default HinduismPage;